import React, { useState, useContext } from "react"
import Button from "../../../../../components/Button"
import FolderSelect from "../../FolderSelect"
import PropTypes from "prop-types"
import { Mutation } from "react-apollo"
import MOVE_FAVORITE_FILE from "../../../../../graphql/moveFavoriteFile.graphql"
import { ModalMessage } from "../../../../../components/Modal"
import { REMOVE_FROM_FOLDER_OPTION } from "../../../constants"
import AppContext from "../../../../../shared/AppContext"

import "./style.scss"

const MESSAGE_TYPE = {
  SUCCESS: "success",
  SAVE_ERROR: "saveError",
  REQUIRED: "isRequired",
}

const MoveFavorite = (props) => {
  const [folderName, setFolderName] = useState("")
  const [folderId, setFolderId] = useState("")
  const [message, setMessage] = useState({ type: "", text: "" })
  const { trackEvent } = useContext(AppContext)

  const {
    refetchQuery,
    currentFolderId,
    trackingLocation,
    favoriteName,
  } = props

  const handleCloseModal = () => {
    props.closeModal()
    if (refetchQuery) {
      refetchQuery()
    }
  }

  const moveFavoriteFile = async (mutate) => {
    const isRemoveFromFolderSelected = folderName === REMOVE_FROM_FOLDER_OPTION

    if (!folderId && !isRemoveFromFolderSelected) {
      return setMessage({
        type: MESSAGE_TYPE.REQUIRED,
        text: "Please select a folder.",
      })
    }

    const mutationVariables = {
      favoriteId: props.favoriteId,
      folderId: folderId,
      removeFromFolder: isRemoveFromFolderSelected,
    }

    mutate({
      variables: mutationVariables,
    })
      .then(({ data }) => {
        const { moveFavoriteFile } = data
        setMessage({
          type: moveFavoriteFile.response.payload,
          text: moveFavoriteFile.response.message,
        })

        if (
          moveFavoriteFile.response &&
          moveFavoriteFile.response.payload === MESSAGE_TYPE.SUCCESS
        ) {
          trackEvent("Moved Favorite", {
            location: trackingLocation,
            favoriteName: favoriteName,
            toFolder:
              folderName === REMOVE_FROM_FOLDER_OPTION
                ? "Removed from the folder and placed into the All Favorites section"
                : folderName,
          })
        }
      })
      .catch((err) => {
        setMessage({
          type: MESSAGE_TYPE.SAVE_ERROR,
          text:
            "Oh no! Something went wrong. Please go to https://app.etr.ai/help to get support.",
        })
        console.log("Favorite move error", err)
      })
  }

  if (message.type == MESSAGE_TYPE.SUCCESS) {
    return (
      <ModalMessage
        messageType={MESSAGE_TYPE.SUCCESS}
        text={message.text}
        closeModal={handleCloseModal}
      />
    )
  }

  return (
    <Mutation mutation={MOVE_FAVORITE_FILE}>
      {(mutate) => {
        return (
          <div className="move-favorite-container">
            <div className="move-favorite-inputs">
              {props.currentFolderName && (
                <div className="move-favorite-label">
                  <span>
                    Current Folder: <i>{props.currentFolderName}</i>
                  </span>
                </div>
              )}
              <div className="move-favorite-input-label">
                <span>Move to: </span>
              </div>
              {message.type == MESSAGE_TYPE.REQUIRED && (
                <ModalMessage
                  messageType={MESSAGE_TYPE.SAVE_ERROR}
                  text={message.text}
                  style={{ textAlign: "left" }}
                />
              )}
              <FolderSelect
                folderName={folderName}
                setFolderName={(folderName) => setFolderName(folderName)}
                setFolderId={(folderId) => setFolderId(folderId)}
                currentFolderId={currentFolderId}
              />
            </div>
            {message.type == MESSAGE_TYPE.SAVE_ERROR && (
              <ModalMessage
                messageType={MESSAGE_TYPE.SAVE_ERROR}
                text={message.text}
                style={{ textAlign: "right" }}
              />
            )}
            <div className="move-favorite-buttons-container">
              <Button
                action={props.closeModal}
                classes={["move-favorite-cancel-button"]}
                text={"Cancel"}
              />
              <Button
                action={() => moveFavoriteFile(mutate)}
                classes={["move-favorite-action-button"]}
                text={"Move File"}
              />
            </div>
          </div>
        )
      }}
    </Mutation>
  )
}

MoveFavorite.propTypes = {
  closeModal: PropTypes.func.isRequired,
  currentFolder: PropTypes.string,
  favoriteId: PropTypes.string.isRequired,
}

MoveFavorite.defaultProps = {
  currentFolder: "",
}

export default MoveFavorite
